import React, { useCallback, useLayoutEffect } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { jsonArray, jsonValue } from '../../types/jsonValue';
import {
  completedComponentIdsState, compositedScenarioItemState,
} from '../../stores/scenarioState';
import { currentFormValuesState, inputFormState, inputItemErrorsState } from '../../stores/formState';
import { completedComponentState } from '../../stores/completedComponentState';

export interface OkButtonProps {
  componentId: string;
  label?: string;
  watchingIds: string[];
}

const isEmpty = (value: jsonValue | jsonArray) => {
  return value == null || value === '' || (value instanceof Array && value.length === 0);
}

const OkButton: React.FC<OkButtonProps> = props => {
  const setCompletedItemIds = useSetRecoilState(completedComponentIdsState);
  const [completed, complete] = useRecoilState(completedComponentState(props.componentId));
  const formValues = useRecoilValue(currentFormValuesState);
  const scenarioItem = useRecoilValue(compositedScenarioItemState(props.componentId));
  const inputForm = useRecoilValue(inputFormState(scenarioItem.id));
  const inputErrors = useRecoilValue(inputItemErrorsState(scenarioItem.id));

  useLayoutEffect(() => {
    complete(false);
  }, [inputForm, complete])

  const onClick = useCallback(() => {
    const componentIds = scenarioItem.components.map(c => c.id);
    setCompletedItemIds(prev => [...prev, ...componentIds.filter(id => !prev.includes(id))]);
  }, [scenarioItem, setCompletedItemIds]);

  const hasError = Object.entries(inputErrors).length > 0;
  const hasRemainInput = scenarioItem.components.filter(i => 'optional' in i && !i.optional)
    .map(c => c.id)
    .filter(id => isEmpty(formValues[id])).length > 0;

  const disabled = completed || hasError || hasRemainInput;

  return (
    <div className="ok-button">
      <button type="button" onClick={onClick} disabled={disabled}>{props.label || '→すすむ'}</button>
    </div>);
};

export default OkButton;
